// extracted by mini-css-extract-plugin
export default {"small":"Stack-module__small___1_oX-","medium":"Stack-module__medium___2BeLz","large":"Stack-module__large___1akWS"};